<woa-field [label]="label()" [link]="link()" [message]="message()" [translationParams]="translationParams()"
           [readOnly]="readOnly()" [disabled]="disabled()" [defaultInput]="input" (onActivateLink)="onActivateLink.emit()">
    <div class="date-field">
        <input #input class="date-field-input" [attr.id]="inputId()"
               [value]="displayValue()" (input)="handleInputEvent($event)"
               type="date" [attr.autocomplete]="autocomplete()" [readOnly]="readOnly()"
               [attr.aria-labelledby]="labelId()" [attr.aria-describedby]="describedBy()" [attr.aria-invalid]="ariaInvalid()">
        @if (!valueSignal()) {
            <div class="date-field-placeholder">
                {{ placeholder() | translate: translationParams() }}
            </div>
        }
        <woa-icon class="date-field-icon" [name]="'calendar'"></woa-icon>
    </div>
</woa-field>
